import Flickity from 'flickity';

export default {
  init($element) {
  },
  finalize($element) {
    if ($element.find('.standard-gallery-carousel')) {
      const standardGalleryCarousel = new Flickity($element.find('.standard-gallery-carousel').get()[0], {
        // adaptiveHeight: true,
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        groupCells: true,
        contain: true,
        on: {
          ready: function () {
            window.dispatchEvent(new Event('resize')); // Quickfix for sizing issue
          },
        },
      });

      // Set a tab index of negative -1 for all CTA's that are hidden from view.
      $element.find('.standard-gallery-carousel').find('.carousel-cell').each(function (e) {
        if ($(this).attr('aria-hidden') === 'true') {
          $(this).find('.image-item .global-lightbox-open').attr('tabindex', -1);
        }
      });

      // Scroll buttons
      $element.find('.progress-slide-arrow-prev').on('click', function () {
        standardGalleryCarousel.previous();
      });

      $element.find('.progress-slide-arrow-next').on('click', function (i) {
        standardGalleryCarousel.next();
      });

      const sliderWidth = ($element.find('.progress-slider-wrap').outerWidth() / standardGalleryCarousel.slides.length) + 'px';
      $element.find('.progress-slider-inner').css({width: sliderWidth});

      standardGalleryCarousel.on('change', function (i) {
        var slideDistance = '';
        if (i == 0) {
          slideDistance = '0';
        } else {
          const slidePercentage = ((i + 1) / standardGalleryCarousel.slides.length) * 100;
          const sliderWidth = $element.find('.progress-slider-inner').outerWidth();
          slideDistance = `calc(${slidePercentage}% - ${sliderWidth}px)`;
        }

        $element.find('.progress-slider-inner').css({left: slideDistance});

        if (i == 0) {
          $element.find('.progress-slide-arrow-prev').addClass('disabled');
        } else {
          $element.find('.progress-slide-arrow-prev').removeClass('disabled');
        }

        if (i + 1 >= standardGalleryCarousel.slides.length) {
          $element.find('.progress-slide-arrow-next').addClass('disabled');
        } else {
          $element.find('.progress-slide-arrow-next').removeClass('disabled');
        }

        // Set a tab index of negative -1 for all CTA's that are hidden from
        // view. If a cell is not hidden from view, then make the cell
        // tabbable by removing the negative tab index to re-enable it in the
        // DOM.
        $element.find('.standard-gallery-carousel').find('.carousel-cell').each(function (e) {
          if ($(this).attr('aria-hidden') === 'true') {
            $(this).find('.image-item .global-lightbox-open').attr('tabindex', -1);
          } else {
            $(this).find('.image-item .global-lightbox-open').removeAttr('tabindex');
          }
        });
      });
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/partials/shared/standardGallery.js